import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Seckilllist from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface SeckilllistState extends ListState<Seckilllist> {
    editSeckilllist: Seckilllist;
}
class SeckilllistModule extends ListModule<SeckilllistState, any, Seckilllist> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Seckilllist>(),
        loading: false,
        editTemplate: new Seckilllist(),
        seckillVersion: 0,
        seckillProductInfo: [],
        seckillActInfo: [],
        limitedVersion: 0,
        limitedProductInfo: [],
        limitedActInfo: [],
        newpurchaseProductInfo: [],
        newpurchaseActInfo: []
    };
    public actions = {
        async getAll(context: ActionContext<SeckilllistState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/BuyLimit/GetBuyLimitList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Seckilllist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        //tips 营销类列表可以放在一起，减少ts数量
        async getPreorderList(context: ActionContext<SeckilllistState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/PreOrder/GetPreOrderList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Seckilllist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    public mutations = {
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key]
            }
        },
        setCurrentPage(state: SeckilllistState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SeckilllistState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: SeckilllistState, Seckilllist: Seckilllist) {
            state.editSeckilllist = Seckilllist;
        },
    };
}
const seckilllistModule = new SeckilllistModule();
export default seckilllistModule;
